import { object } from "../helpers/object";
import { debug } from "../helpers/debug";

class Captcha {

  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;

    this.loadCaptcha();
    if(debug.DEBUG) console.log('components/captcha.js');
  }
  setCaptchaToken = (captchaArray) => {
    turnstile.ready(function () {
      captchaArray.forEach((elem) => {
        turnstile.render(elem, {
            sitekey: captchsitekey,
            callback: function(token) {
                console.log(`Challenge Success ${token}`);
            },
        });
      });
    });
};
  reset = () => {
    if (typeof captchsitekey === 'undefined') return;
    turnstile.reset();
  }
  loadCaptcha = () => {
    if (typeof captchsitekey === 'undefined') return;
    const captchaArray = [];
    this.DOM_MODULE.forEach((element) => {
      captchaArray.push(`#${element.id}`);
    });
    this.setCaptchaToken(captchaArray);
  }

}
export const captcha = new Captcha('[data-js-component="captcha"]'); 